import Head from "next/head";
import { useRouter } from "next/router";

export const FeedHead = () => {
  const { locale, defaultLocale } = useRouter();
  const prefix = locale === defaultLocale ? "/" : `/${locale}/`;
  const feedUrl = `https://www.whoppah.com${prefix}rss`;
  return (
    <Head>
      <link rel="alternate" type="application/rss+xml" href={feedUrl} />
    </Head>
  );
};
